import { calc, storage } from '@ok/blade';

const calcGetAmount = ({ isFiat, payAmount, exchangePrice, precision }) => {
  if (!payAmount) {
    return '';
  }

  let getAmount = '';

  if (isFiat) {
    getAmount = calc.div(payAmount, exchangePrice);
  } else {
    getAmount = calc.mul(payAmount, exchangePrice);
  }

  return calc.floorTruncate(getAmount, precision, false);
};

const calcPayAmount = ({ isFiat, getAmount, exchangePrice, precision }) => {
  if (!getAmount) {
    return '';
  }
  let payAmount = '';
  if (isFiat) {
    payAmount = calc.div(getAmount, exchangePrice);
  } else {
    payAmount = calc.mul(getAmount, exchangePrice);
  }

  // Accuracy loss is borne by the user
  return calc.ceilTruncate(payAmount, precision, false);
};

// Get JPY limit and current amount
const getAmountLimitJpy = ({
  payAmount,
  getAmount,
  isFiat,
  exchangePrice,
  min,
  max,
}) => {
  const jpyAmount = isFiat ? payAmount : getAmount;
  return {
    currentMount: jpyAmount,
    minimum: calc.floorMul(min, exchangePrice, 2),
    maximum: calc.floorMul(max, exchangePrice, 2),
  };
};

const formatZero = (value) => {
  if (value.indexOf('.') > 0) {
    return value;
  }
  if (value.length > 0 && value == 0) {
    return '0';
  }
  if (value.indexOf('0') == 0) {
    return value.slice(1);
  }
  return value;
};

const getCurrencyNameByUrl = () => {
  const defaultCurrencyName = 'btc';
  const pathNames = window.location.pathname.split('/');
  const currencyName = pathNames[pathNames.length - 1] || defaultCurrencyName;
  return currencyName.toUpperCase();
};

const fetchUtil = async (url) => {
  const result = await fetch(url);
  return result.json();
};

const showFloorTruncationWithPlaceholder = (value, placeholder = '--') => {
  return value ? calc.showFloorTruncation(value) : placeholder;
};

const currencyInfoStorage = storage.init({
  project: 'currencyInfo',
});

const getCurCurrencyByUrl = (currencyList) => {
  if (!currencyList) {
    return {};
  }

  const currencyName = getCurrencyNameByUrl();
  let curCurrency = currencyList?.find(({ symbol }) => symbol === currencyName);
  if (!curCurrency) {
    curCurrency = currencyList?.[0];
  }
  return curCurrency;
};

export {
  calcGetAmount,
  calcPayAmount,
  getAmountLimitJpy,
  formatZero,
  getCurrencyNameByUrl,
  fetchUtil,
  showFloorTruncationWithPlaceholder,
  currencyInfoStorage,
  getCurCurrencyByUrl,
};
